import Route from 'route-parser';
import routes from '../../routes';
import findActiveRoute from '../../helpers/findActiveRoute';
import {
  removeBrandPathFromRoute,
  removeSitePathFromRoute,
} from '../../helpers';
import { localeInPath } from '../../helpers/locale';

function normalizePathname(pathname = '') {
  const decodedPath = decodeURIComponent(pathname);
  let pathWithoutTrailingSlashes = decodedPath;

  while (
    pathWithoutTrailingSlashes.length > 1 &&
    pathWithoutTrailingSlashes.endsWith('/')
  ) {
    pathWithoutTrailingSlashes = pathWithoutTrailingSlashes.slice(0, -1);
  }

  return pathWithoutTrailingSlashes || '/';
}

function getNormalizedRoutePath(
  activeRoute,
  pathname,
  singleSiteMode,
  brandSubPath,
) {
  let routePath = localeInPath(pathname)
    ? activeRoute.path
    : activeRoute.path.replace('/:lng', '');

  if (singleSiteMode) {
    routePath = removeSitePathFromRoute(routePath);
  }

  if (!brandSubPath) {
    routePath = removeBrandPathFromRoute(routePath);
  }

  return routePath;
}

export function parseLandingRouteParams(pathname = '', options = {}) {
  const {
    siteType,
    audienceType,
    isPreview = false,
    singleSiteMode = false,
    brandSubPath,
    newPaymentJourneyEnabled,
  } = options;

  if (!siteType) {
    return { landingGroupPath: '', landingPath: '' };
  }

  const path = normalizePathname(pathname);
  const activeRoute = findActiveRoute({
    path,
    isPreview,
    siteType,
    audienceType,
    routes,
    singleSiteMode,
    brandSubPath,
    newPaymentJourneyEnabled,
  });

  if (!activeRoute?.path?.includes(':landingGroupPath')) {
    return { landingGroupPath: '', landingPath: '' };
  }

  const routePath = getNormalizedRoutePath(
    activeRoute,
    path,
    singleSiteMode,
    brandSubPath,
  );
  const params = new Route(routePath).match(path);

  if (!params?.landingGroupPath) {
    return { landingGroupPath: '', landingPath: '' };
  }

  return {
    landingGroupPath: String(params.landingGroupPath).toLowerCase(),
    landingPath: String(params.landingPath || '').toLowerCase(),
  };
}
